import { render } from "./PieChart2.vue?vue&type=template&id=f322631e&scoped=true"
import script from "./PieChart2.vue?vue&type=script&lang=js"
export * from "./PieChart2.vue?vue&type=script&lang=js"

import "./PieChart2.vue?vue&type=style&index=0&id=f322631e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f322631e"]])

export default __exports__